/**
 * Created by jonas on 2020-05-12.
 */
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {bonusWheelEvents} from "../gameround/bonusWheelController";
import {ImmortalFruitsGameModuleConfig} from "../ImmortalFruitsGameModuleConfig";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {ImmortalFruitsReelBackgroundView} from "../reelBackground/ImmortalFruitsReelBackgroundView";

export class ImmortalFruitsExitGambleTransitionController extends GameModeTransitionController{

    constructor(fromMode: string, toMode: string) {
        super(fromMode, toMode);
    }

    protected prepareToEnterMode() {
        EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.HIDE_WHEELS));
    }

    protected cleanUpBeforeModeStart() {
        ImmortalFruitsReelBackgroundView.resetAllSymsToNormal();
    }
}